export enum Domains {
    DOMAIN_ADD_LIMIT = 500,
}
